import { BalanceSheetCategoryInterface } from '@/interfaces/balanceSheet';

export const calculateTotalAssets = (
  assets: BalanceSheetCategoryInterface,
): number => {
  // Either return the precomputed total or sum up category totals
  if (assets.total) {
    return assets.total;
  }

  // Fallback to summing up categories
  return assets.categories.reduce(
    (total, category) => total + category.total,
    0,
  );
};

export const calculateFormattedNetWorth = (
  totalAssets: number,
  totalLiabilities: number,
): string => {
  const netWorth = totalAssets - totalLiabilities;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(netWorth);
};
